// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1P2Um","col":"styles_col__Qgvkd"};